import { APPLICANT_QUESTIONS } from '@funnels/constants';
import { Question } from '@funnels/types';

export function getPPSApplicantDisplayFields(questions: Question[]) {
  const hasCountryOfBirth = questions.some((q: Question) => q === APPLICANT_QUESTIONS.COUNTRY_OF_BIRTH);
  const hasCityOfBirth = questions.some((q: Question) => q === APPLICANT_QUESTIONS.CITY_OF_BIRTH);
  const hasCitizenship = questions.some((q: Question) => q === APPLICANT_QUESTIONS.COUNTRY_OF_CITIZENSHIP);
  const hasMothersMaidenName = questions.some((q: Question) => q === APPLICANT_QUESTIONS.MOTHERS_MAIDEN_NAME);
  const hasContactFirstName = questions.some((q: Question) => q === APPLICANT_QUESTIONS.SPOUSE_FIRST_NAME);
  const hasContactLastName = questions.some((q: Question) => q === APPLICANT_QUESTIONS.SPOUSE_LAST_NAME);
  const hasContactTitle = questions.some((q: Question) => q === APPLICANT_QUESTIONS.SPOUSE_TITLE);
  const hasPostSettlementAddress = questions.some(
    (q: Question) => q === APPLICANT_QUESTIONS.POST_SETTLEMENT_MAILING_ADDRESS
  );
  const hasSubstantialBenefits = questions.some((q: Question) => q === APPLICANT_QUESTIONS.SUBSTANTIAL_BENEFITS);

  return {
    hasCountryOfBirth,
    hasCitizenship,
    hasCityOfBirth,
    hasMothersMaidenName,
    hasContactFirstName,
    hasContactLastName,
    hasContactTitle,
    hasPostSettlementAddress,
    hasSubstantialBenefits,
  };
}
